var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { getMyneedsEOSForNetwell, getMyneedsEOS_UHF } from "./handlers";
import MyShareRequestsTable from "./MyShareRequestTable";
import { useCommonLoader } from "../Loader";
import config from "../../assests/config";
const MyShareRequestsWrapper = styled("section")(({ theme }) => ({
    "&#noneeds_error": {
        margin: "0px auto",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    minHeight: "40vh",
    fontFamily: ["Roboto", "sans-serif"].join(","),
    ".noneeds_msg_display": {
        color: "black",
        fontWeight: 500,
        textAlign: "center",
        margin: 5,
    },
    ".MuiButtonBase-root": {
        backgroundColor: "transparent !important",
    },
}));
export const MyShareRequests = (props) => {
    var _a, _b, _c;
    const { setLoading, unSetLoading } = useCommonLoader();
    const [loader, setLoader] = useState(false);
    const [myNeedsEOS, setMyNeedsEOS] = useState({
        data: [],
        error: {
            notfoundmsg1: "No share requests have been entered into the system.",
            notfoundmsg2: "Submitted needs may take 2-3 days to be displayed here.",
            notfoundmsg3: "For any clarifications call Customer Service.",
        },
    });
    const fetchIntialData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading();
            setLoader(true);
            const myNeedsEOS = yield getMyneedsEOSForNetwell({
                appConfig: {
                    brand: config.netwell,
                },
                mode: "dev",
            });
            setMyNeedsEOS((prevState) => (Object.assign(Object.assign({}, prevState), { data: myNeedsEOS })));
            unSetLoading();
            setLoader(false);
        }
        catch (error) {
            console.log(error);
            unSetLoading();
            setLoader(false);
        }
    });
    const fetch_UHF_MYNEEDSEOS = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading();
            setLoader(true);
            const myNeedsEOS = yield getMyneedsEOS_UHF({ mode: props.mode || "dev" });
            setMyNeedsEOS((prevState) => (Object.assign(Object.assign({}, prevState), { data: myNeedsEOS })));
            unSetLoading();
            setLoader(false);
        }
        catch (error) {
            unSetLoading();
            setLoader(false);
        }
    });
    useEffect(() => {
        props.brand === config.uhf ? fetch_UHF_MYNEEDSEOS() : fetchIntialData();
    }, []);
    if (!(myNeedsEOS === null || myNeedsEOS === void 0 ? void 0 : myNeedsEOS.data.length) && !loader)
        return (React.createElement(MyShareRequestsWrapper, { id: "noneeds_error" },
            React.createElement("p", { className: "noneeds_msg_display" }, (_a = myNeedsEOS === null || myNeedsEOS === void 0 ? void 0 : myNeedsEOS.error) === null || _a === void 0 ? void 0 : _a.notfoundmsg1),
            React.createElement("p", { className: "noneeds_msg_display" }, (_b = myNeedsEOS === null || myNeedsEOS === void 0 ? void 0 : myNeedsEOS.error) === null || _b === void 0 ? void 0 : _b.notfoundmsg2),
            React.createElement("p", { className: "noneeds_msg_display" }, (_c = myNeedsEOS === null || myNeedsEOS === void 0 ? void 0 : myNeedsEOS.error) === null || _c === void 0 ? void 0 : _c.notfoundmsg3)));
    return (React.createElement(MyShareRequestsWrapper, { id: "my_share_requests" }, (myNeedsEOS.data || []).length ? (React.createElement(MyShareRequestsTable, { data: myNeedsEOS.data, brand: props.brand })) : null));
};
